module.exports = __webpack_public_path__ + "img/loginbg.eada9461.jpg";